// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicCustomerProfileControllerCreateData } from './PublicCustomerProfileControllerCreateData.gen';
import type { PublicCustomerProfileControllerCreateErrors } from './PublicCustomerProfileControllerCreateErrors.gen';
import type { PublicCustomerProfileControllerCreateResponses } from './PublicCustomerProfileControllerCreateResponses.gen';
import type { PublicCustomerProfileControllerDeleteData } from './PublicCustomerProfileControllerDeleteData.gen';
import type { PublicCustomerProfileControllerDeleteErrors } from './PublicCustomerProfileControllerDeleteErrors.gen';
import type { PublicCustomerProfileControllerDeleteResponses } from './PublicCustomerProfileControllerDeleteResponses.gen';
import type { PublicCustomerProfileControllerGetAllData } from './PublicCustomerProfileControllerGetAllData.gen';
import type { PublicCustomerProfileControllerGetAllErrors } from './PublicCustomerProfileControllerGetAllErrors.gen';
import type { PublicCustomerProfileControllerGetAllResponses } from './PublicCustomerProfileControllerGetAllResponses.gen';
import type { PublicCustomerProfileControllerGetOneData } from './PublicCustomerProfileControllerGetOneData.gen';
import type { PublicCustomerProfileControllerGetOneErrors } from './PublicCustomerProfileControllerGetOneErrors.gen';
import type { PublicCustomerProfileControllerGetOneResponses } from './PublicCustomerProfileControllerGetOneResponses.gen';
import type { PublicCustomerProfileControllerGetRegularData } from './PublicCustomerProfileControllerGetRegularData.gen';
import type { PublicCustomerProfileControllerGetRegularErrors } from './PublicCustomerProfileControllerGetRegularErrors.gen';
import type { PublicCustomerProfileControllerGetRegularResponses } from './PublicCustomerProfileControllerGetRegularResponses.gen';
import type { PublicCustomerProfileControllerUpdateData } from './PublicCustomerProfileControllerUpdateData.gen';
import type { PublicCustomerProfileControllerUpdateErrors } from './PublicCustomerProfileControllerUpdateErrors.gen';
import type { PublicCustomerProfileControllerUpdateResponses } from './PublicCustomerProfileControllerUpdateResponses.gen';

export class PublicCustomerProfileController {
    /**
     * Get customer profiles.
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicCustomerProfileControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicCustomerProfileControllerGetAllResponses, PublicCustomerProfileControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/customer-profiles',
            ...options
        });
    }
    
    /**
     * Create customer profile.
     *
     * Require: `PERMISSION_CUSTOMER-PROFILES_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_VALID_TO** - ValidFrom is after ValidTo OR New ValidFrom is null or new validFrom is before old ValidFrom.<br>
     * + **INVALID_CUSTOMER_PROFILE_TYPE** - Customer profile type does not exist or for the given ticket combination does not match with card.<br>
     * + **INVALID_CUSTOMER_PROFILE_VALID_TO_DEFAULT** - Customer profile validTo default does not exist.<br>
     * + **INVALID_CUSTOMER_PROFILE** - Customer profile does not exist, is not valid for the customer, is impersonal, is not primary or has invalid properties combination.
     */
    public static create<ThrowOnError extends boolean = false>(options: Options<PublicCustomerProfileControllerCreateData, ThrowOnError>) {
        return (options.client ?? client).post<PublicCustomerProfileControllerCreateResponses, PublicCustomerProfileControllerCreateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/customer-profiles',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get regular customer profile.
     *
     * Require: `PERMISSION_CUSTOMER-PROFILES_VIEW`
     */
    public static getRegular<ThrowOnError extends boolean = false>(options?: Options<PublicCustomerProfileControllerGetRegularData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicCustomerProfileControllerGetRegularResponses, PublicCustomerProfileControllerGetRegularErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/customer-profiles/regular',
            ...options
        });
    }
    
    /**
     * Delete customer profile.
     *
     * If an entity is being used, 409 Conflict will be returned.<br>
     * Require: `PERMISSION_CUSTOMER-PROFILES_DELETE`
     */
    public static delete<ThrowOnError extends boolean = false>(options: Options<PublicCustomerProfileControllerDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<PublicCustomerProfileControllerDeleteResponses, PublicCustomerProfileControllerDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/customer-profiles/{id}',
            ...options
        });
    }
    
    /**
     * Get customer profile by id.
     *
     * Require: `PERMISSION_CUSTOMER-PROFILES_VIEW`
     */
    public static getOne<ThrowOnError extends boolean = false>(options: Options<PublicCustomerProfileControllerGetOneData, ThrowOnError>) {
        return (options.client ?? client).get<PublicCustomerProfileControllerGetOneResponses, PublicCustomerProfileControllerGetOneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/customer-profiles/{id}',
            ...options
        });
    }
    
    /**
     * Update customer profile names.
     *
     * Require: `PERMISSION_CUSTOMER-PROFILES_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_VALID_TO** - Valid to must be bigger than valid from or is in the past.
     */
    public static update<ThrowOnError extends boolean = false>(options: Options<PublicCustomerProfileControllerUpdateData, ThrowOnError>) {
        return (options.client ?? client).put<PublicCustomerProfileControllerUpdateResponses, PublicCustomerProfileControllerUpdateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/customer-profiles/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
